"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../common/helpers/time");
var StudentDrivesViewReportCardController = /** @class */ (function () {
    function StudentDrivesViewReportCardController($state, UsersModel, ReportcardsModel, $stateParams, UserService, VueStoreFactory, FlashService) {
        var _this = this;
        this.$state = $state;
        this.reportCard = null;
        this.loading = true;
        this.ReportcardsModel = ReportcardsModel;
        this.VueStoreFactory = VueStoreFactory;
        this.FlashService = FlashService;
        this.saveSignature = this.saveSignature.bind(this);
        var data = {
            student_id: UserService.getCurrentUser().id,
            drive_id: $stateParams.id,
        };
        UsersModel.getReportcardForDrive(data)
            .then(function (response) {
            _this.reportCard = response.reportcard;
            _this.loading = false;
        })
            .catch(function (Error) {
            _this.loading = false;
        });
    }
    StudentDrivesViewReportCardController.prototype.reportcardHasSignature = function (reportcard, type) {
        if (!reportcard.signatures) {
            return false;
        }
        return reportcard.signatures.some(function (signature) { return signature.signee_type === type; });
    };
    StudentDrivesViewReportCardController.prototype.studentIsMinor = function () {
        var dob = this.VueStoreFactory.state.auth.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
        return (0, time_1.isMinor)(dob.meta_value);
    };
    StudentDrivesViewReportCardController.prototype.saveSignature = function (signature) {
        var _this = this;
        this.ReportcardsModel.submitSignature(this.reportCard.id, signature, "student")
            .then(function () {
            _this.$state.go("drivecoach.student.dashboard");
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: Error.data.message,
            });
        });
    };
    return StudentDrivesViewReportCardController;
}());
StudentDrivesViewReportCardController.$inject = [
    "$state",
    "UsersModel",
    "ReportcardsModel",
    "$stateParams",
    "UserService",
    "VueStoreFactory",
    "FlashService",
];
exports.default = StudentDrivesViewReportCardController;
